<template>
  <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.214,0H2.786A2.786,2.786,0,0,0,0,2.788V17.645a2.786,2.786,0,0,0,2.786,2.786h3.3l-.505,4.541a.929.929,0,0,0,1.544.792l5.926-5.333H23.214A2.786,2.786,0,0,0,26,17.645V2.788A2.786,2.786,0,0,0,23.214,0Z" />
  </svg>
</template>